import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import * as queryString from 'query-string';
import { hasRequiredEngageOAuthParams } from '../../utils/oauth';

export default (ChildComponent) => {
    const RequireAuth = (props) => {
        const { pathname, search } = props.location;
        const parsed = queryString.parse(search);
        const { loggedOutAction } = parsed;
        const redirectUrl = encodeURIComponent(`${pathname}${search}`);
        switch (props.auth.user) {
            case null:
                if (pathname === '/explore') {
                    return <ChildComponent {...props} />;
                }
                if (props.staticContext) {
                    props.staticContext.status = 302;
                }
                if (pathname === '/search') {
                    return <Redirect to={`/login?flow=search&next=${redirectUrl}`} />;
                }

                if (hasRequiredEngageOAuthParams(props.location)) {
                    return <Redirect to={`/join?return=${redirectUrl}`} />;
                }

                return (loggedOutAction === 'join')
                    ? <Redirect to={`/join?next=${redirectUrl}`} />
                    : <Redirect to={`/login?next=${redirectUrl}`} />;

            default:
                return <ChildComponent {...props} />;
        }
    };

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps)(withRouter(RequireAuth));
};
